import { Typography } from 'shared/ui'
import { getAriaLabel } from 'shared/lib'
import { AudioPlayer } from 'shared/ui/AudioPlayer'
import type { Attachment } from 'entities/Attachment/model/Attachment'
import { sentEventSentry } from 'entities/Sentry'
import styles from './styles.module.scss'

type IRinglessContentProps = {
  attachments: Attachment[]
}

export const RinglessContent = ({ attachments }: IRinglessContentProps) => {
  const attachment = attachments[0]
  if (attachment) {
    return (
      <div className={styles.wrap}>
        <Typography
          ariaLabel={getAriaLabel('Audi title')}
          variant={'body-md-medium'}
          className={styles.name}
        >
          {attachment.name}
        </Typography>
        <AudioPlayer
          url={attachment.source}
          duration={attachment.duration}
          fullWidth
          showDeliveryInfo
          onError={(error) => {
            sentEventSentry({
              event: '[Audio] RinglessContent - error',
              name: 'audio:error',
              level: 'error',
              error: error,
            })
          }}
        />
      </div>
    )
  }
  return null
}
